export enum JobType {
  FORMAL = 'FORMAL',

  INFORMAL = 'INFORMAL',

  FREELANCER = 'FREELANCER',

  OTHERS = 'OTHERS',
}
